import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  MenuItem,
  AppBar,
  Toolbar,
  InputLabel,
Select,
FormControl,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  InputAdornment,
  DialogContent,
  DialogActions,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
} from "@mui/material";
import { AssignmentTurnedIn } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { keyframes } from "@emotion/react";
import { useParams } from "react-router-dom";
import base64 from "base64-js";
import SearchIcon from '@mui/icons-material/Search';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FilterListIcon from "@mui/icons-material/FilterList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BusinessIcon from "@mui/icons-material/Business";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CloseIcon from "@mui/icons-material/Close";



// Animations
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideIn = keyframes`
  from { transform: translateY(30px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

// Styled Components
const StyledPaper = styled(Paper)({
  padding: "30px",
  margin: "auto",
  marginTop: "24px",
  width: "97%",
  borderRadius: "15px",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  backgroundColor: "#fff",
  animation: `${slideIn} 0.5s ease-out`,
});

const StyledAppBar = styled(AppBar)({
  backgroundColor: '#0B1F40', // dark navy blue
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
});

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    },
  },
});

const StyledButton = styled(Button)({
  borderRadius: "25px",
  padding: "10px 20px",
  backgroundColor: "#1976d2",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#115293",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
  },
});

const StyledTableContainer = styled(TableContainer)({
  borderRadius: "10px",
  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
  animation: `${fadeIn} 0.5s ease-in`,
});

const EmployeeAttendance = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [canAdd, setCanAdd] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const navigate = useNavigate();
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // For search results
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [attendanceDetails, setAttendanceDetails] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // For search input
const [departments, setDepartments] = useState([]);
const [selectedDepartment, setSelectedDepartment] = useState("All Departments");
const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  const decodeFormId = (encodedFormId) => {
    if (!encodedFormId || typeof encodedFormId !== "string") {
      console.error("encodedFormId is missing or invalid:", encodedFormId);
      return null;
    }
    try {
      const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
      const bytes = base64.toByteArray(paddedEncodedFormId);
      return new TextDecoder().decode(bytes);
    } catch (error) {
      console.error("Error decoding formId:", error);
      return null;
    }
  };

  const { encodedFormId } = useParams();
  const formId = decodeFormId(encodedFormId);

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
      });

      const result = await response.json();
      const data = result[0];

      // setAuthorization(data);
      setCanEdit(data?.uModify === 1);
      setCanAdd(data?.uWrite === 1);
      setCanDelete(data?.uDelete === 1);
    } catch (error) {
      console.error("Authorization check failed:", error);
    }
  };


  const token = sessionStorage.getItem("token");

  // FIX: Auto-select the first branch for master users after fetching,
  // so the branch dropdown is pre-filled on load.
  const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);

      // Auto-fill: pre-select the first branch if no branch is selected yet
      if (data && data.length > 0 && !selectedBranchId) {
        setSelectedBranchId(data[0].branchId);
      }
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};

  const fetchDepartments = async () => {
  try {
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/Department/DepartmentName`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
    });
    if (!response.ok) throw new Error("Failed to fetch departments");
    const data = await response.json();
     setDepartments(Array.isArray(data) ? data : []);
  } catch (error) {
    setError("Could not load departments.");
  }
};

// Updated fetchEmployeeData (main fix for data mapping)
// FIX: Accept branchId as a parameter to avoid stale state issues on initial load.
// For non-master users, branchId is read directly from sessionStorage as a fallback.
const fetchEmployeeData = async (branchId) => {
  try {
    setLoading(true);
    const url = process.env.REACT_APP_BASE_URL;

    // Use passed branchId, or fall back to current state, or sessionStorage for non-master users
    const resolvedBranchId = branchId ?? selectedBranchId ?? sessionStorage.getItem("branchId");

    const apiUrl = `${url}/Employee/GetEmployee?Branch_Id=${resolvedBranchId}`;
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
    });

    if (!response.ok) throw new Error("Failed to fetch employee data");
    const data = await response.json();

    // Safely handle if API returns direct array or wrapped object
    const employeeList = Array.isArray(data) ? data : (Array.isArray(data.data) ? data.data : []);
    
    setAttendanceData(employeeList);
    setFilteredData(employeeList); // Initialize filtered data
  } catch (error) {
    setError(error.message);
  } finally {
    setLoading(false);
  }
};

  const fetchFinancialYears = async () => {
    const url = process.env.REACT_APP_BASE_URL;
    const apiUrl = `${url}/ClassPromotion/GetFinancialYear`;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error("Failed to fetch financial years");
      const data = await response.json();
      setYearOptions(data);

      // Auto-select current financial year
      const today = new Date();
      const currentYear = today.getFullYear();
      const nextYear = currentYear + 1;

      const financialYearStart = new Date(currentYear, 3, 1); // April 1st
      const financialYearEnd = new Date(nextYear, 2, 31); // March 31st

      let currentSessionString;
      if (today >= financialYearStart && today <= financialYearEnd) {
        currentSessionString = `${currentYear}-${nextYear}`;
      } else {
        currentSessionString = `${currentYear - 1}-${currentYear}`;
      }

      const currentSession = data.find(
        (item) => item.finanacialYear === currentSessionString
      );
      if (currentSession) {
        setSelectedYear(currentSession.financialYearID);
      } else {
        setSelectedYear(data[0]?.financialYearID || ""); // Fallback to first option
      }
    } catch (error) {
      setError("Could not load financial years.");
    }
  };

  const fetchEmployeeAttendance = async (employeeId) => {
    try {
      setLoading(true);
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/EmployeeAttendance/GetEmployeeAttendance`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({ employeeId, yearId: selectedYear }),
      });

      if (!response.ok) throw new Error("Failed to fetch attendance details");
      const data = await response.json();
      setAttendanceDetails(data.attendanceData);
      setModalOpen(true);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

 const handleSearch = (query, dept = selectedDepartment) => {
  let filtered = [...attendanceData];
  if (query.trim()) {
    const lowerQuery = query.toLowerCase();
    filtered = filtered.filter((employee) => {
      const employeeCode = employee.employeeCode?.toLowerCase() || "";
      const employeeName = employee.employeeName?.toLowerCase() || "";
      return (
        employeeCode.includes(lowerQuery) ||
        employeeName.includes(lowerQuery)
      );
    });
  }
  if (dept) {
    filtered = filtered.filter(
      (employee) => employee.departmentName === dept
    );
  }
  setFilteredData(filtered);
};


 const handleSearchChange = (e) => {
  const query = e.target.value;
  setSearchQuery(query);
  handleSearch(query, selectedDepartment);
};

const handleDepartmentChange = (e) => {
  const dept = e.target.value;
  setSelectedDepartment(dept);
  handleSearch(searchQuery, dept);
};

  // Helper function to get academic year months in order (April to March)
  const getAcademicYearMonths = () => {
    return [
      "April", "May", "June", "July", "August", "September",
      "October", "November", "December", "January", "February", "March"
    ];
  };

  // Helper function to get days in a month
  const getDaysInMonth = (monthName, year) => {
    const monthIndex = {
      "January": 0, "February": 1, "March": 2, "April": 3,
      "May": 4, "June": 5, "July": 6, "August": 7,
      "September": 8, "October": 9, "November": 10, "December": 11
    };
    
    const selectedYearObj = yearOptions.find(y => y.financialYearID === selectedYear);
    if (!selectedYearObj) return 31;
    
    const [startYear, endYear] = selectedYearObj.finanacialYear.split('-').map(Number);
    
    // Determine which year to use based on month
    const useYear = ["January", "February", "March"].includes(monthName) ? endYear : startYear;
    
    return new Date(useYear, monthIndex[monthName] + 1, 0).getDate();
  };

  // Organize attendance data by academic year
  const organizeAttendanceByAcademicYear = (attendanceData) => {
    if (!attendanceData || attendanceData.length === 0) return {};
    
    const organized = {};
    const academicMonths = getAcademicYearMonths();
    
    // Initialize all months with empty arrays
    academicMonths.forEach(month => {
      organized[month] = Array(31).fill("");
    });
    
    // Fill in the attendance data
    attendanceData.forEach(({ month, day, attendanceStatus }) => {
      if (organized[month]) {
        organized[month][day - 1] = attendanceStatus;
      }
    });
    
    return organized;
  };

  // FIX: Re-fetch employee data whenever selectedBranchId changes (handles branch dropdown changes)
  useEffect(() => {
  if (selectedBranchId) {
    fetchEmployeeData(selectedBranchId);
  }
}, [selectedBranchId]);


  useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  if (isMasterUser) {
    // For master users: fetchBranches will auto-select the first branch,
    // which triggers the selectedBranchId useEffect above to load employees
    fetchBranches();
  } else {
    // For non-master users: read branchId directly from sessionStorage
    // and pass it explicitly to avoid stale state on initial render
    const branchId = sessionStorage.getItem("branchId");
    setSelectedBranchId(branchId);
    fetchEmployeeData(branchId); // Pass branchId directly to avoid race condition
  }

  fetchFinancialYears();
  fetchDepartments();
  Authorizer();
}, []);


  const closeModal = () => setModalOpen(false);

  const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(1); // reset to page 1
};

const paginatedData = filteredData.slice(
  (page - 1) * rowsPerPage,
  page * rowsPerPage
);

  return (
    <Container>
     <AppBar
  position="static"
  sx={{
    backgroundColor: "#0B1F3D",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
  }}
>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
    
    {/* Left: Title + Info Button */}
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          letterSpacing: "0.5px",
          color: "#ffffff",
        }}
      >
        Employee Attendance
      </Typography>

      {/* ── Info Button ── */}
      <Tooltip title="About this page" arrow>
        <IconButton
          onClick={() => setInfoOpen(true)}
          size="small"
          sx={{
            color: "rgba(255,255,255,0.75)",
            border: "1.5px solid rgba(255,255,255,0.35)",
            borderRadius: "50%",
            width: 30,
            height: 30,
            ml: 0.5,
            transition: "all 0.2s ease",
            "&:hover": {
              color: "#ffffff",
              backgroundColor: "rgba(100,181,246,0.2)",
              borderColor: "#64B5F6",
              transform: "scale(1.1)",
              boxShadow: "0 0 8px rgba(100,181,246,0.4)",
            },
          }}
        >
          <InfoOutlinedIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </Box>

    {/* Right: Branch Dropdown */}
   {isMaster && (
  <Box sx={{ position: "relative" }}>
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.75rem",
          fontWeight: 500,
          letterSpacing: "0.6px",
          textTransform: "uppercase",
          top: "-2px",
          "&.Mui-focused": { color: "#64B5F6" },
          "&.MuiFormLabel-filled": { color: "rgba(255,255,255,0.7)" },
        }}
      >
        Branch
      </InputLabel>
      <Select
        value={selectedBranchId || ""}
        onChange={(e) => setSelectedBranchId(e.target.value)}
        label="Branch"
        startAdornment={
          <InputAdornment position="start">
            <LocationOnIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.5)", ml: 0.5 }} />
          </InputAdornment>
        }
        sx={{
          color: "#ffffff",
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.3px",
          backgroundColor: "rgba(255,255,255,0.07)",
          backdropFilter: "blur(8px)",
          borderRadius: "8px",
          transition: "background-color 0.2s ease, box-shadow 0.2s ease",

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.15)",
            borderWidth: "1px",
            transition: "border-color 0.2s ease",
          },
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.11)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "rgba(255,255,255,0.35)",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(255,255,255,0.1)",
            boxShadow: "0 0 0 3px rgba(100,181,246,0.18)",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#64B5F6",
              borderWidth: "1.5px",
            },
          },
          "& .MuiSelect-icon": {
            color: "rgba(255,255,255,0.5)",
            transition: "color 0.2s ease",
          },
          "&.Mui-focused .MuiSelect-icon": {
            color: "#64B5F6",
          },
          "& .MuiSelect-select": {
            py: 1.1,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              mt: 0.5,
              borderRadius: "10px",
              border: "1px solid rgba(11,31,61,0.12)",
              boxShadow: "0 8px 32px rgba(11,31,61,0.18), 0 2px 8px rgba(0,0,0,0.08)",
              overflow: "hidden",
              "& .MuiList-root": { py: 0.5 },
            },
          },
        }}
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.branchId}
            value={branch.branchId}
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#0B1F3D",
              px: 2,
              py: 1.1,
              mx: 0.5,
              borderRadius: "6px",
              transition: "background-color 0.15s ease",
              "&:hover": {
                backgroundColor: "rgba(11,31,61,0.07)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(25,118,210,0.1)",
                color: "#1565C0",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(25,118,210,0.15)",
                },
              },
            }}  
          >
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Box>
)}
  </Toolbar>
</AppBar>

      <Paper
        style={{
          padding: "20px",
          maxWidth: "1200px",
          margin: "auto",
          marginTop: "2px",
        }}
        elevation={4}
      >


     <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    mb: 3,
    gap: 2,
    flexWrap: "wrap",
  }}
>
  {/* Left side: Search & Filters */}
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      flex: 1,
      minWidth: 0, // prevents overflow
    }}
  >
    <StyledTextField
      label="Search by Code or Name"
      variant="outlined"
      value={searchQuery}
      onChange={handleSearchChange}
      sx={{ width: "300px" }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />

    <StyledTextField
      select
      label="Financial Year"
      value={selectedYear}
      onChange={(e) => setSelectedYear(e.target.value)}
      SelectProps={{ native: true }}
      sx={{ width: "180px" }}
    >
      {yearOptions.map((year) => (
        <option key={year.financialYearID} value={year.financialYearID}>
          {year.finanacialYear}
        </option>
      ))}
    </StyledTextField>

    <StyledTextField
      select
      label="Department"
      value={selectedDepartment}
      onChange={handleDepartmentChange}
      SelectProps={{ native: true }}
      sx={{ width: "180px" }}
      InputLabelProps={{ shrink: true }}
    >
      <option value="">All Departments</option>
      {departments.map((dept) => (
        <option key={dept.deptId} value={dept.departmentName}>
          {dept.departmentName}
        </option>
      ))}
    </StyledTextField>
  </Box>

  {/* Right side: Add Attendance Button */}
  <Tooltip title={!canAdd && "You are not Authorized to Add"} arrow>
    <span>
      <Button
        variant="contained"
        color="primary"
        sx={{
          width: "160px",
          height: "56px", // matches default MUI TextField height
          fontWeight: "bold",
          flexShrink: 0,
          whiteSpace: "nowrap",
        }}
        onClick={() => navigate("/empattendance-form")}
        disabled={!canAdd}
      >
        Add Attendance
      </Button>
    </span>
  </Tooltip>
</Box>




        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" sx={{ textAlign: "center", my: 4 }}>
            {error}
          </Typography>
        ) : (
          <StyledTableContainer component={Paper} style={{ marginTop: 16 }}>
            <Table
              stickyHeader
              sx={{
                minWidth: 650,
                border: '1px solid #ccc',
                '& .MuiTableCell-root': {
                  borderRight: '1px solid #ccc',
                  fontSize: '1rem',
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Serial No
                  </TableCell>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Employee Code
                  </TableCell>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Employee Name
                  </TableCell>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Department
                  </TableCell>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem' }}>
                    Designation
                  </TableCell>
                  <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  paginatedData.map((employee, index) => (
                    <TableRow
                      key={employee.employeeID}
                      sx={{
                        borderTop: '1px solid #ccc',
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        transition: "background-color 0.2s ease",
                      }}
                    >
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        {index + 1}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        {employee.employeeCode}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        {employee.employeeName}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        {employee.departmentName}
                      </TableCell>
                      <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        {employee.designationName}
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                        <Tooltip title="View Attendance" arrow>
                          <IconButton
                            color="primary"
                            onClick={() => fetchEmployeeAttendance(employee.employeeID)}
                            sx={{
                              "&:hover": { transform: "scale(1.1)" },
                              transition: "transform 0.2s ease",
                            }}
                          >
                            <AssignmentTurnedIn />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No employees found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </StyledTableContainer>

        )}
        {filteredData.length > 0 && (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 2 }}>
    <TextField
      select
      label="Rows per page"
      value={rowsPerPage}
      onChange={handleChangeRowsPerPage}
      sx={{ width: 150 }}
      SelectProps={{
        native: true,
      }}
    >
      {rowsPerPageOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </TextField>

    <Box>
      <Typography variant="body2" sx={{ display: 'inline-block', marginRight: 2 }}>
        Page {page} of {Math.ceil(filteredData.length / rowsPerPage)}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page - 1)}
        disabled={page === 1}
        sx={{ mr: 1 }}
      >
        Prev
      </Button>
      <Button
        variant="outlined"
        onClick={() => handleChangePage(null, page + 1)}
        disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
      >
        Next
      </Button>
    </Box>
  </Box>
)}


        {/* Attendance Modal - Updated to show Academic Year */}
        <Dialog
          open={modalOpen}
          onClose={closeModal}
          maxWidth="lg"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "15px",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          <DialogTitle
            sx={{
              background: "linear-gradient(45deg, #3f51b5 30%, #1976d2 90%)",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Attendance Register - Academic Year {yearOptions.find(y => y.financialYearID === selectedYear)?.finanacialYear}
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            {attendanceDetails && attendanceDetails.length > 0 ? (
              <TableContainer sx={{ maxHeight: 400, overflow: "auto" }}>
                <Table
                  stickyHeader
                  sx={{ minWidth: 800, border: "1px solid #e0e0e0" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#f5f5f5",
                          zIndex: 1,
                          minWidth: "120px"
                        }}
                      >
                        Month
                      </TableCell>
                      {Array.from({ length: 31 }, (_, i) => (
                        <TableCell
                          key={i + 1}
                          sx={{
                            fontWeight: "bold",
                            textAlign: "center",
                            backgroundColor: "#f5f5f5",
                            minWidth: "40px"
                          }}
                        >
                          {i + 1}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(() => {
                      const organizedData = organizeAttendanceByAcademicYear(attendanceDetails);
                      const academicMonths = getAcademicYearMonths();
                      
                      return academicMonths.map((month) => {
                        const statuses = organizedData[month] || Array(31).fill("");
                        const daysInMonth = getDaysInMonth(month, selectedYear);
                        
                        return (
                          <TableRow
                            key={month}
                            sx={{ "&:hover": { backgroundColor: "#f9f9f9" } }}
                          >
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                position: "sticky",
                                left: 0,
                                backgroundColor: "#f0f0f0",
                                zIndex: 1,
                              }}
                            >
                              {month}
                            </TableCell>
                            {statuses.map((status, index) => {
                              const dayNumber = index + 1;
                              const isValidDay = dayNumber <= daysInMonth;
                              
                              return (
                                <TableCell
                                  key={index}
                                  sx={{
                                    textAlign: "center",
                                    backgroundColor: !isValidDay ? "#f5f5f5" : "inherit",
                                    color:
                                      status === "Present"
                                        ? "green"
                                        : status === "Absent"
                                          ? "red"
                                          : status === "N/A"
                                            ? "#d3d3d3"
                                            : "black",
                                    fontWeight: status ? "bold" : "normal",
                                  }}
                                >
                                  {isValidDay ? (status || "-") : ""}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      });
                    })()}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography sx={{ textAlign: "center", py: 2 }}>
                No attendance data available
              </Typography>
            )}
          </DialogContent>
          <DialogActions sx={{ backgroundColor: "#f5f5f5", p: 2 }}>
            <Button
              onClick={closeModal}
              sx={{
                backgroundColor: "#3f51b5",
                color: "white",
                "&:hover": { backgroundColor: "#2c387e" },
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* ── Info Dialog ── */}
        <Dialog
          open={infoOpen}
          onClose={() => setInfoOpen(false)}
          maxWidth="sm"
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: "16px",
              boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
              overflow: "hidden",
            },
          }}
        >
          {/* Header */}
          <DialogTitle
            sx={{
              background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "1.2rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 3,
              py: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <InfoOutlinedIcon sx={{ fontSize: 22 }} />
              Employee Attendance — Page Guide
            </Box>
            <IconButton
              onClick={() => setInfoOpen(false)}
              size="small"
              sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ px: 3, py: 2.5 }}>

            {/* Purpose */}
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
              This page allows you to view and manage attendance records for all employees
              across departments and financial years. Use the tools below to search, filter,
              and inspect individual attendance registers.
            </Typography>

            <Divider sx={{ mb: 2 }} />

            {/* Features */}
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
              Features &amp; Controls
            </Typography>

            <List dense disablePadding>
              <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                  <SearchIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight={600}>Search by Code or Name</Typography>}
                  secondary="Instantly filter the employee list by typing an employee code or name."
                />
              </ListItem>

              <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                  <CalendarMonthIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight={600}>Financial Year</Typography>}
                  secondary="Select the academic/financial year to view attendance for that period (April–March cycle)."
                />
              </ListItem>

              <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                  <BusinessIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight={600}>Department Filter</Typography>}
                  secondary="Narrow results to a specific department or view all departments at once."
                />
              </ListItem>

              {isMaster && (
                <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                  <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                    <LocationOnIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography variant="body2" fontWeight={600}>Branch Selector (Master Only)</Typography>}
                    secondary="Switch between branches in the top-right dropdown to load that branch's employees."
                  />
                </ListItem>
              )}

              <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                  <VisibilityIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight={600}>View Attendance Register</Typography>}
                  secondary="Click the register icon (✔) in the Actions column to open the full monthly attendance grid for that employee."
                />
              </ListItem>

              <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
                <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                  <AssignmentIcon sx={{ fontSize: 20, color: "#1976d2" }} />
                </ListItemIcon>
                <ListItemText
                  primary={<Typography variant="body2" fontWeight={600}>Add Attendance</Typography>}
                  secondary="Use the 'Add Attendance' button (top-right of the table area) to record new attendance entries. Requires Add permission."
                />
              </ListItem>
            </List>

            <Divider sx={{ my: 2 }} />

            {/* Legend */}
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
              Attendance Status Legend
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              <Chip
                icon={<CheckCircleOutlineIcon sx={{ fontSize: 16, color: "green !important" }} />}
                label="Present"
                size="small"
                sx={{ fontWeight: 600, color: "green", border: "1px solid green", backgroundColor: "#f0fff4" }}
                variant="outlined"
              />
              <Chip
                icon={<CancelOutlinedIcon sx={{ fontSize: 16, color: "red !important" }} />}
                label="Absent"
                size="small"
                sx={{ fontWeight: 600, color: "red", border: "1px solid red", backgroundColor: "#fff5f5" }}
                variant="outlined"
              />
              <Chip
                icon={<RemoveCircleOutlineIcon sx={{ fontSize: 16, color: "#aaa !important" }} />}
                label="N/A"
                size="small"
                sx={{ fontWeight: 600, color: "#aaa", border: "1px solid #aaa", backgroundColor: "#fafafa" }}
                variant="outlined"
              />
              <Chip
                label="— (No Record)"
                size="small"
                sx={{ fontWeight: 600, color: "#555", border: "1px solid #ccc", backgroundColor: "#f5f5f5" }}
                variant="outlined"
              />
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Permissions note */}
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
              Permissions
            </Typography>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Chip label={`Add: ${canAdd ? "✔ Allowed" : "✘ Restricted"}`} size="small"
                sx={{ backgroundColor: canAdd ? "#e8f5e9" : "#fce4ec", color: canAdd ? "green" : "red", fontWeight: 600 }} />
              <Chip label={`Edit: ${canEdit ? "✔ Allowed" : "✘ Restricted"}`} size="small"
                sx={{ backgroundColor: canEdit ? "#e8f5e9" : "#fce4ec", color: canEdit ? "green" : "red", fontWeight: 600 }} />
              <Chip label={`Delete: ${canDelete ? "✔ Allowed" : "✘ Restricted"}`} size="small"
                sx={{ backgroundColor: canDelete ? "#e8f5e9" : "#fce4ec", color: canDelete ? "green" : "red", fontWeight: 600 }} />
            </Box>

          </DialogContent>

          <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
            <Button
              onClick={() => setInfoOpen(false)}
              variant="contained"
              sx={{
                backgroundColor: "#0B1F3D",
                color: "#fff",
                borderRadius: "8px",
                fontWeight: 600,
                "&:hover": { backgroundColor: "#1565C0" },
              }}
            >
              Got it
            </Button>
          </DialogActions>
        </Dialog>
        {/* ── End Info Dialog ── */}

      </Paper>
    </Container>
  );
};

export default EmployeeAttendance;